import { FC } from 'react';
import { Card } from '@/components/ui/card';
import { Target } from 'lucide-react';

export const EligibilityCard: FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Card className="p-6 bg-white/80 backdrop-blur-sm border border-gray-200/50 shadow-lg">
      <div className="space-y-6">
        <div className="flex items-center gap-3">
          <Target className="h-8 w-8 text-primary" />
          <h2 className="text-2xl font-semibold text-gray-800">Requisitos del Programa</h2>
        </div>

        <div className="prose max-w-none">
          <p className="text-gray-600">
            Para participar en nuestro programa de socios, necesitas cumplir con los siguientes requisitos:
          </p>
        </div>

        {children}
      </div>
    </Card>
  );
};